import { Component } from '@angular/core';

@Component({
  selector: 'app-radar-link',
  templateUrl: './radar-link.component.html',
  styleUrls: ['./radar-link.component.scss']
})
export class RadarLinkComponent {

}
